import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const OPTION_TYPE_KINDS = [
  'color',
  'size',
]

const entityColumns = {
  id: {
    model_name: 'OptionType',
    column_type: 'id',
    label_key_path: 'optionType.id',
  },
  created_at: {
    model_name: 'OptionType',
    column_type: 'datetime',
    label_key_path: 'optionType.createdAt',
  },
  updated_at: {
    model_name: 'OptionType',
    column_type: 'datetime',
    label_key_path: 'optionType.updatedAt',
  },
  name: {
    model_name: 'OptionType',
    column_type: 'string',
    label_key_path: 'optionType.name',
  },
  kind: {
    model_name: 'OptionType',
    column_type: 'enum',
    extra: {
      options: ['color', 'size'],
    },
    label_key_path: 'optionType.kind',
  },
  option_values: {
    model_name: 'OptionType',
    column_type: 'has_many',
    label_key_path: 'optionType.optionValues',
    extra: {
      association_name: 'option_values',
      model_name: 'OptionValue',
      foreign_key: 'option_type_id',
      display_column: 'name',
    },
  },
  option_value_ids: {
    model_name: 'OptionType',
    column_type: 'has_many',
    label_key_path: 'optionType.optionValues',
    extra: {
      association_name: 'option_values',
      model_name: 'OptionValue',
      foreign_key: 'option_type_id',
      display_column: 'name',
    },
  },
  option_values_attributes: {
    model_name: 'OptionType',
    column_type: 'string',
    label_key_path: 'optionType.optionValuesAttributes',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
